import { useAppBridge } from "@shopify/app-bridge-react"

import { usePrompt } from "@/hooks/usePrompt"

// 内部组件：只在 Shopify App Bridge 环境下使用 useAppBridge
// 用于拦截所有导航（包括子路由），当有未保存更改时阻止跳转
function ShopifyNavigationBlocker({ when }: { when: boolean }) {
  const appBridge = useAppBridge()

  usePrompt(([target]) => {
    // 当有未保存更改时，拦截所有导航（包括子路由如 /tracking-page/）
    if (when) {
      // 调用 SaveBar 的 leaveConfirmation 来显示确认对话框
      // 返回 false 阻止导航
      appBridge?.saveBar?.leaveConfirmation?.()
      return false
    }
    // 没有未保存更改时，允许导航
    return true
  }, when)

  return null
}

export { ShopifyNavigationBlocker }
